module.exports = {
	"1": [
		[
			[
				"1:27/24-27"
			],
			[
				"But just you wait, just you wait..."
			]
		],
		[
			[
				"1:54/54"
			],
			[
				"Just you wait!"
			]
		],
		[
			[
				"1:76/75-76"
			],
			[
				"But just you wait!"
			]
		],
		[
			[
				"3:139/115-142"
			],
			[
				"I’m past patiently waitin’. I’m passionately smashin’ every expectation"
			]
		],
		[
			[
				"11:34/33-34"
			],
			[
				"Just you wait, just you wait…"
			]
		],
		[
			[
				"12:54/53-54"
			],
			[
				"If you love this woman, go get her! What are you waiting for?"
			]
		],
		[
			[
				"13:17/1-25",
				"13:18/1-25"
			],
			[
				"Then I'm willing to wait for it",
				"I'm willing to wait for it"
			]
		],
		[
			[
				"13:36/26-38",
				"13:39/39-41",
				"13:41/39-41"
			],
			[
				"I’m willing to wait for it",
				"I’m willing to wait for it",
				"Wait for it",
				"Wait for it",
				"Wait for it",
				"Wait for it"
			]
		],
		[
			[
				"13:43/43-46",
				"13:46/43-46"
			],
			[
				"Wait for it",
				"Wait for it",
				"Wait for it",
				"Wait for it"
			]
		],
		[
			[
				"13:49/49-52",
				"13:52/49-52"
			],
			[
				"Wait for it",
				"Wait for it",
				"Wait for it",
				"Wait for it"
			]
		],
		[
			[
				"13:54/54-57",
				"13:57/54-57"
			],
			[
				"Wait for it",
				"Wait for it",
				"Wait for it",
				"Wait for it"
			]
		],
		[
			[
				"13:59/58-59",
				"13:60/60-62",
				"13:62/60-62"
			],
			[
				"I am lying in wait",
				"Wait",
				"Wait",
				"Wait"
			]
		],
		[
			[
				"13:87/78-98",
				"13:88/78-98"
			],
			[
				"I'm willing to wait for it",
				"I'm willing to wait for it..."
			]
		],
		[
			[
				"13:97/78-98",
				"13:98/78-98"
			],
			[
				"Wait for it...",
				"Wait for it..."
			]
		],
		[
			[
				"23:92/91-93"
			],
			[
				"What are you waiting for?"
			]
		],
		[
			[
				"23:107/105-113"
			],
			[
				"I’ll wait here and see"
			]
		],
		[
			[
				"26:31/30-31"
			],
			[
				"And it cannot wait"
			]
		],
		[
			[
				"26:84/77-84"
			],
			[
				"But I’m crossing the ocean and I just can’t wait"
			]
		],
		[
			[
				"28:123/123"
			],
			[
				"Wait for it, wait for it, wait!"
			]
		],
		[
			[
				"36:35/35",
				"36:36/36-37",
				"36:37/36-37"
			],
			[
				"Wait for it, wait for it, wait for it…",
				"Wait for it, wait for it, wait for it…",
				"Wait for it, wait for it, wait for it, wait…"
			]
		],
		[
			[
				"36:44/44"
			],
			[
				"Wait for it, wait for it, wait for it, wait…"
			]
		],
		[
			[
				"36:44/44"
			],
			[
				"Wait for it, wait for it, wait for it, wait…"
			]
		],
		[
			[
				"45:72/72-76"
			],
			[
				"Wait!"
			]
		]
	],
	"3": [
		[
			[
				"2:2/2"
			],
			[
				"Pardon me. Are you Aaron Burr, sir?"
			]
		],
		[
			[
				"2:4/4-6"
			],
			[
				"Oh, well, sure, sir"
			]
		],
		[
			[
				"2:5/4-6"
			],
			[
				"I’m Alexander Hamilton, I’m at your service, sir"
			]
		],
		[
			[
				"2:8/8-9"
			],
			[
				"Sir…"
			]
		],
		[
			[
				"8:85/85"
			],
			[
				"Your excellency, sir!"
			]
		],
		[
			[
				"8:87/87-88"
			],
			[
				"Aaron Burr, Sir?"
			]
		],
		[
			[
				"8:90/90-96"
			],
			[
				"Sir"
			]
		],
		[
			[
				"8:104/104"
			],
			[
				"Yes, sir"
			]
		],
		[
			[
				"8:106/106"
			],
			[
				"As I was saying, sir, I look forward to seeing your strategy play out"
			]
		],
		[
			[
				"8:108/108"
			],
			[
				"Sir?"
			]
		],
		[
			[
				"8:110/110"
			],
			[
				"Have I done something wrong, sir?"
			]
		],
		[
			[
				"8:114/114"
			],
			[
				"Sir?"
			]
		],
		[
			[
				"8:116/116"
			],
			[
				"Sir!"
			]
		],
		[
			[
				"8:146/143-146"
			],
			[
				"I’ll rise above my station, organize your information, ‘til we rise to the occasion of our new nation. Sir!"
			]
		],
		[
			[
				"12:20/20"
			],
			[
				"Sir"
			]
		],
		[
			[
				"12:45/45"
			],
			[
				"You’re very kind, but I’m afraid it’s unlawful, sir"
			]
		],
		[
			[
				"14:10/10"
			],
			[
				"But, sir!"
			]
		],
		[
			[
				"14:53/53"
			],
			[
				"Ready, sir!"
			]
		],
		[
			[
				"14:55/55"
			],
			[
				"Yes, sir!"
			]
		],
		[
			[
				"14:67/67"
			],
			[
				"But, sir!"
			]
		],
		[
			[
				"15:35/35"
			],
			[
				"Aaron Burr, sir"
			]
		],
		[
			[
				"15:39/39"
			],
			[
				"With his life? We both know that’s absurd, sir"
			]
		],
		[
			[
				"16:11/11"
			],
			[
				"Yes, sir"
			]
		],
		[
			[
				"16:17/17"
			],
			[
				"Sir!"
			]
		],
		[
			[
				"16:47/47"
			],
			[
				"Sir—"
			]
		],
		[
			[
				"16:47/47"
			],
			[
				"Sir—"
			]
		],
		[
			[
				"18:29/29-30"
			],
			[
				"Sir, he knows what to do in a trench"
			]
		],
		[
			[
				"18:32/32-33"
			],
			[
				"Sir, you’re gonna have to use him eventually"
			]
		],
		[
			[
				"23:61/61"
			],
			[
				"Aaron Burr, sir"
			]
		],
		[
			[
				"23:63/63"
			],
			[
				"Can we confer, sir?"
			]
		],
		[
			[
				"24:79/78-79"
			],
			[
				"Sir, you’ve been off in Paris for so long!"
			]
		],
		[
			[
				"24:79/78-79"
			],
			[
				"Sir, you’ve been off in Paris for so long!"
			]
		],
		[
			[
				"25:2/1-2"
			],
			[
				"The issue on the table: Secretary Hamilton’s plan to assume state debt and establish a national bank. Secretary Jefferson, you have the floor, sir"
			]
		],
		[
			[
				"25:50/50"
			],
			[
				"Sir!"
			]
		],
		[
			[
				"25:73/73"
			],
			[
				"Sir—"
			]
		],
		[
			[
				"25:73/73"
			],
			[
				"Sir—"
			]
		],
		[
			[
				"27:21/21"
			],
			[
				"You’re too kind, sir"
			]
		],
		[
			[
				"27:24/24"
			],
			[
				"This one’s mine, sir"
			]
		],
		[
			[
				"27:58/58-61"
			],
			[
				"Dear Sir, I hope this letter finds you in good health"
			]
		],
		[
			[
				"27:70/70"
			],
			[
				"No, sir!"
			]
		],
		[
			[
				"27:72/72"
			],
			[
				"Please don’t go, sir!"
			]
		],
		[
			[
				"28:2/2"
			],
			[
				"Mister Burr, sir"
			]
		],
		[
			[
				"30:1/1"
			],
			[
				"The issue on the table: France is on the verge of war with England, and do we provide aid and our troops to our French allies or do we stay out of it? Remember, my decision on this matter is not subject to congressional approval. The only person you have to convince is me. Secretary Jefferson, you have the floor, sir"
			]
		],
		[
			[
				"30:33/33"
			],
			[
				"But sir, do we not fight for freedom?"
			]
		],
		[
			[
				"30:39/39"
			],
			[
				"Sir"
			]
		],
		[
			[
				"32:3/3"
			],
			[
				"What do you need, sir? Sir?"
			]
		],
		[
			[
				"32:5/5"
			],
			[
				"Sir, I don’t know what you heard but whatever it is, Jefferson started it"
			]
		],
		[
			[
				"32:9/9"
			],
			[
				"Whatever you say, sir, Jefferson will pay for his behavior"
			]
		],
		[
			[
				"32:16/16"
			],
			[
				"Ha. Good luck defeating you, sir"
			]
		],
		[
			[
				"32:26/26"
			],
			[
				"No, sir, why?"
			]
		],
		[
			[
				"32:28/28"
			],
			[
				"Sir, with Britain and France on the verge of war, is this the best time—"
			]
		],
		[
			[
				"42:53/53"
			],
			[
				"Well, if it isn’t Aaron Burr. Sir!"
			]
		],
		[
			[
				"42:55/55"
			],
			[
				"You’ve created quite a stir, sir!"
			]
		],
		[
			[
				"42:62/62"
			],
			[
				"Sir!"
			]
		],
		[
			[
				"43:28/14-29"
			],
			[
				"I have the honor to be Your Obedient Servant"
			]
		],
		[
			[
				"43:44/39-45"
			],
			[
				"I have the honor to be Your Obedient Servant"
			]
		],
		[
			[
				"43:58/58"
			],
			[
				"I have the honor to be Your Obedient Servant"
			]
		]
	],
	"4": [
		[
			[
				"2:22/21-22"
			],
			[
				"Talk less"
			]
		],
		[
			[
				"2:24/24"
			],
			[
				"Smile more"
			]
		],
		[
			[
				"2:26/26"
			],
			[
				"Don’t let them know what you’re against or what you’re for"
			]
		],
		[
			[
				"12:51/51-52"
			],
			[
				"Congrats again, Alexander. Smile more"
			]
		],
		[
			[
				"23:51/51-53",
				"23:52/51-53"
			],
			[
				"Why do you always say what you believe?",
				"Why do you always say what you believe?"
			]
		],
		[
			[
				"28:16/16"
			],
			[
				"“Talk less. Smile more.”"
			]
		],
		[
			[
				"32:10/10"
			],
			[
				"Shh. Talk less"
			]
		],
		[
			[
				"42:26/26-32",
				"42:28/26-32"
			],
			[
				"Talk less!",
				"Smile more!",
				"Don’t let ‘em know what you’re against or what you’re for!"
			]
		]
	],
	"5": [
		[
			[
				"13:58/58-59"
			],
			[
				"I’m not standing still"
			]
		],
		[
			[
				"14:32/31-35"
			],
			[
				"We pick and choose our battles and places to take a stand"
			]
		],
		[
			[
				"23:103/101-104",
				"23:104/101-104"
			],
			[
				"For once in your life, take a stand with pride",
				"I don’t understand how you stand to the side"
			]
		],
		[
			[
				"25:21/13-24"
			],
			[
				"Stand with me in the land of the free"
			]
		],
		[
			[
				"28:129/127-130",
				"28:130/127-130"
			],
			[
				"If you stand for nothing",
				"Burr, what do you fall for?"
			]
		],
		[
			[
				"30:9/7-18",
				"30:11/7-18"
			],
			[
				"And stand with them if they fought against oppressors",
				"And revolution is messy but now is the time to stand",
				"Stand with our brothers as they fight against tyranny"
			]
		],
		[
			[
				"42:97/97-98"
			],
			[
				"But when all is said and all is done"
			]
		],
		[
			[
				"43:50/49-53",
				"43:51/49-53"
			],
			[
				"I stand by what I said, every bit of it",
				"You stand only for yourself"
			]
		],
		[
			[
				"43:54/54-56"
			],
			[
				"Then stand, Alexander"
			]
		]
	],
	"6": [
		[
			[
				"3:4/4-23",
				"3:8/4-23"
			],
			[
				"I am not throwing away my shot!",
				"I am not throwing away my shot!",
				"Hey yo, I'm just like my country",
				"I'm young, scrappy and hungry",
				"And I'm not throwing away my shot!"
			]
		],
		[
			[
				"3:36/33-40",
				"3:41/41-46",
				"3:46/41-46"
			],
			[
				"And I am not throwing away my shot",
				"I am not throwing away my shot",
				"Hey yo, I’m just like my country",
				"I’m young, scrappy and hungry",
				"And I’m not throwing away my shot",
				"I am not throwing away my shot",
				"I am not throwing away my shot",
				"Hey yo, I’m just like my country",
				"I’m young, scrappy and hungry",
				"And I’m not throwing away my shot",
				"It’s time to take a shot!"
			]
		],
		[
			[
				"3:51/47-51",
				"3:52/52",
				"3:52/52"
			],
			[
				"With my—",
				"Shot!"
			]
		],
		[
			[
				"3:57/53-57",
				"3:58/58",
				"3:58/58"
			],
			[
				"I’m gonna take a—",
				"Shot!"
			]
		],
		[
			[
				"3:84/84-93",
				"3:93/84-93"
			],
			[
				"I am not throwing away my shot",
				"I am not throwing away my shot",
				"Hey yo, I’m just like my country",
				"I’m young, scrappy and hungry",
				"And I’m not throwing away my shot",
				"I am not throwing away my shot",
				"I am not throwing away my shot",
				"Hey yo, I’m just like my country",
				"I’m young, scrappy and hungry",
				"And I’m not throwing away my shot"
			]
		],
		[
			[
				"3:143/143-147",
				"3:147/143-147"
			],
			[
				"And I am not throwing away my shot",
				"I am not throwing away my shot",
				"Hey yo, I’m just like my country",
				"I’m young, scrappy and hungry",
				"And I’m not throwing away my shot"
			]
		],
		[
			[
				"3:148/148-150",
				"3:149/148-150"
			],
			[
				"We’re gonna rise up! Time to take a shot!",
				"We’re gonna rise up! Time to take a shot!"
			]
		],
		[
			[
				"3:151/151",
				"3:152/152-159",
				"3:160/160",
				"3:161/161",
				"3:161/161"
			],
			[
				"It's time to take a shot!",
				"It's time to take a shot!",
				"Take a shot!",
				"Shot!",
				"Shot!",
				"A-yo it’s",
				"Time to take a shot!",
				"Time to take a shot!",
				"And I am—",
				"Not throwin’ away my—",
				"Not throwin’ away my shot!"
			]
		],
		[
			[
				"8:133/133-135",
				"8:136/136",
				"8:136/136"
			],
			[
				"I am not throwin’ away my shot!",
				"I am not throwin’ away my shot!",
				"Ayo, I’m just like my country, I’m young scrappy and hungry!",
				"I am not throwing away my shot!"
			]
		],
		[
			[
				"20:16/16-20",
				"20:20/16-20"
			],
			[
				"I am not throwin’ away my shot!",
				"I am not throwin’ away my shot!",
				"Hey yo, I’m just like my country, I’m young scrappy and hungry",
				"And I’m not throwin’ away my shot!",
				"I am not throwin’ away my shot!"
			]
		],
		[
			[
				"23:188/188-192",
				"23:192/188-192"
			],
			[
				"I am not throwin’ away my shot!",
				"I am not throwin’ away my shot!",
				"I am",
				"Alexander Hamilton!",
				"I am not throwin’ away my shot!"
			]
		],
		[
			[
				"45:49/43-70"
			],
			[
				"If I throw away my shot, is this how you’ll remember me?"
			]
		]
	],
	"7": [
		[
			[
				"3:106/94-109",
				"3:109/94-109"
			],
			[
				"Rise up!",
				"When you’re living on your knees, you rise up",
				"Tell your brother that he’s gotta rise up",
				"Tell your sister that she's gotta rise up"
			]
		],
		[
			[
				"3:148/148-150",
				"3:149/148-150"
			],
			[
				"We’re gonna rise up! Time to take a shot!",
				"We’re gonna rise up! Time to take a shot!"
			]
		],
		[
			[
				"8:10/10"
			],
			[
				"Rise up!"
			]
		],
		[
			[
				"8:13/13"
			],
			[
				"Rise up!"
			]
		],
		[
			[
				"8:17/17"
			],
			[
				"Rise up!"
			]
		],
		[
			[
				"8:19/19"
			],
			[
				"Rise up! Rise up!"
			]
		],
		[
			[
				"8:146/143-146"
			],
			[
				"I’ll rise above my station, organize your information, ‘til we rise to the occasion of our new nation. Sir!"
			]
		],
		[
			[
				"8:148/148-149",
				"8:149/148-149"
			],
			[
				"Rise up!",
				"Rise up!"
			]
		],
		[
			[
				"8:151/151"
			],
			[
				"Rise up!"
			]
		],
		[
			[
				"23:7/5-8"
			],
			[
				"How to account for his rise to the top?"
			]
		],
		[
			[
				"45:56/43-70",
				"45:57/43-70"
			],
			[
				"A place where even orphan immigrants",
				"Can leave their fingerprints and rise up"
			]
		],
		[
			[
				"45:66/43-70"
			],
			[
				"Rise up, rise up, rise up"
			]
		]
	],
	"8": [
		[
			[
				"3:115/115-142",
				"3:118/115-142"
			],
			[
				"I imagine death so much it feels more like a memory",
				"When’s it gonna get me?",
				"In my sleep? Seven feet ahead of me?",
				"If I see it comin’, do I run or do I let it be?"
			]
		],
		[
			[
				"16:41/41"
			],
			[
				"Or you could die and we need you alive"
			]
		],
		[
			[
				"16:42/42"
			],
			[
				"I’m more than willing to die—"
			]
		],
		[
			[
				"20:23/23-33",
				"20:26/23-33"
			],
			[
				"I imagine death so much it feels more like a memory",
				"This is where it gets me:",
				"On my feet",
				"The enemy ahead of me"
			]
		],
		[
			[
				"23:28/28-31",
				"23:30/28-31"
			],
			[
				"Why do you write like you’re running out of time?",
				"Write day and night like you’re running out of time?",
				"Ev’ry day you fight, like you’re running out of time"
			]
		],
		[
			[
				"23:131/129-134",
				"23:135/135-138",
				"23:138/135-138"
			],
			[
				"How do you write like you’re",
				"Running out of time?",
				"Write day and night like you’re",
				"Running out of time?",
				"Ev’ry day you fight like you’re",
				"Running out of time like you’re",
				"Running out of time",
				"Are you running out of time?"
			]
		],
		[
			[
				"23:185/182-186"
			],
			[
				"Why do you fight like you’re running out of time?"
			]
		],
		[
			[
				"36:8/1-34"
			],
			[
				"I couldn’t seem to die"
			]
		],
		[
			[
				"36:34/1-34"
			],
			[
				"I couldn’t seem to die"
			]
		],
		[
			[
				"44:5/5"
			],
			[
				"Why do you write like you’re running out of time?"
			]
		],
		[
			[
				"45:43/43-70",
				"45:45/43-70"
			],
			[
				"I imagine death so much it feels more like a memory",
				"Is this where it gets me, on my feet, sev’ral feet ahead of me?",
				"I see it coming, do I run or fire my gun or let it be?"
			]
		],
		[
			[
				"45:58/43-70"
			],
			[
				"I’m running out of time. I’m running, and my time’s up"
			]
		],
		[
			[
				"46:36/35-36",
				"46:37/37",
				"46:37/37"
			],
			[
				"You really do write like you’re running out of—",
				"Time"
			]
		]
	],
	"10": [
		[
			[
				"5:25/25-26"
			],
			[
				"But—look around, look around, the"
			]
		],
		[
			[
				"5:34/34"
			],
			[
				"Look around, look around—"
			]
		],
		[
			[
				"5:61/61-62",
				"5:63/63-64",
				"5:64/63-64"
			],
			[
				"Look around, look around at how",
				"Lucky we are to be alive right now!",
				"Look around, look around at how",
				"Lucky we are to be alive right now!"
			]
		],
		[
			[
				"5:75/75-76"
			],
			[
				"Look around, look around at how lucky we are to be alive right now!"
			]
		],
		[
			[
				"14:1/1",
				"14:2/2",
				"14:2/2"
			],
			[
				"Stay alive…",
				"Stay alive…"
			]
		],
		[
			[
				"14:23/23-24"
			],
			[
				"Stay alive ‘til this horror show is past"
			]
		],
		[
			[
				"16:41/41"
			],
			[
				"Or you could die and we need you alive"
			]
		],
		[
			[
				"16:43/43"
			],
			[
				"Your wife needs you alive, son, I need you alive—"
			]
		],
		[
			[
				"17:1/1-3",
				"17:3/1-3"
			],
			[
				"Look around, look around at how lucky we are",
				"To be alive right now",
				"Look around, look around…"
			]
		],
		[
			[
				"17:15/11-15"
			],
			[
				"Look around, look around at how lucky we are to be alive right now."
			]
		],
		[
			[
				"17:19/18-45",
				"17:22/18-45"
			],
			[
				"Look around, look around…",
				"Look at where you are",
				"Look at where you started",
				"The fact that you’re alive is a miracle"
			]
		],
		[
			[
				"17:23/18-45"
			],
			[
				"Just stay alive, that would be enough"
			]
		],
		[
			[
				"23:122/122-128",
				"23:125/122-128"
			],
			[
				"Look at where you are",
				"Look at where you started",
				"The fact that you’re alive is a miracle",
				"Just stay alive, that would be enough"
			]
		],
		[
			[
				"23:157/157"
			],
			[
				"Look around, look around at how lucky we are to be alive right now"
			]
		],
		[
			[
				"23:160/160"
			],
			[
				"Look around, isn’t this enough?"
			]
		],
		[
			[
				"23:172/168-175",
				"23:173/168-175"
			],
			[
				"Look around",
				"Look around!"
			]
		],
		[
			[
				"26:113/107-117",
				"26:114/107-117"
			],
			[
				"Look around, look around",
				"At how lucky we are to be alive right now—"
			]
		],
		[
			[
				"40:1/1-3",
				"40:3/1-3"
			],
			[
				"Stay alive…",
				"Stay alive…",
				"Stay alive..."
			]
		],
		[
			[
				"41:46/46"
			],
			[
				"Look around, look around, Eliza"
			]
		]
	],
	"11": [
		[
			[
				"8:34/29-45"
			],
			[
				"Ayo, I’m gonna need a right-hand man."
			]
		],
		[
			[
				"8:57/47-58"
			],
			[
				"Ayo, I’m gonna need a right-hand man"
			]
		],
		[
			[
				"18:39/39",
				"18:40/40-43",
				"18:43/40-43"
			],
			[
				"I need my right hand man back!",
				"Ah! Uh, get ya right hand man back",
				"You know you gotta get ya right hand man back",
				"I mean you gotta put some thought into the letter but the sooner the better",
				"To get your right hand man back!"
			]
		],
		[
			[
				"23:146/143-146"
			],
			[
				"I’m asking you to be my right hand man"
			]
		]
	],
	"12": [
		[
			[
				"8:127/127"
			],
			[
				"Dying is easy, young man. Living is harder"
			]
		],
		[
			[
				"25:66/66"
			],
			[
				"Winning was easy, young man. Governing’s harder"
			]
		]
	],
	"13": [
		[
			[
				"10:9/9-11",
				"10:10/9-11"
			],
			[
				"Helpless!",
				"Look into your eyes, and the sky’s the limit I’m helpless!"
			]
		],
		[
			[
				"10:23/19-31"
			],
			[
				"Then you look back at me and suddenly I’m helpless!"
			]
		],
		[
			[
				"10:27/19-31"
			],
			[
				"Helpless, I know"
			]
		],
		[
			[
				"10:60/46-67",
				"10:61/46-67"
			],
			[
				"Helpless!",
				"Helpless!"
			]
		],
		[
			[
				"10:65/46-67"
			],
			[
				"Helpless! Helpless!"
			]
		],
		[
			[
				"11:52/52"
			],
			[
				"Helpless…"
			]
		],
		[
			[
				"11:54/54"
			],
			[
				"Helpless…"
			]
		],
		[
			[
				"11:56/56"
			],
			[
				"Helpless…"
			]
		],
		[
			[
				"23:158/158"
			],
			[
				"Helpless…"
			]
		],
		[
			[
				"27:36/31-37"
			],
			[
				"But my God, she looks so helpless"
			]
		],
		[
			[
				"27:78/78-80"
			],
			[
				"Please don’t leave me with him helpless"
			]
		],
		[
			[
				"27:81/81-83"
			],
			[
				"I am helpless—how could I do this?"
			]
		],
		[
			[
				"27:87/84-90"
			],
			[
				"Helpless"
			]
		],
		[
			[
				"27:96/91-101"
			],
			[
				"Cuz the situation’s helpless"
			]
		]
	],
	"14": [
		[
			[
				"11:11/4-23"
			],
			[
				"Be satisfied"
			]
		],
		[
			[
				"11:25/25"
			],
			[
				"You strike me as a woman who has never been satisfied"
			]
		],
		[
			[
				"11:27/27"
			],
			[
				"You’re like me. I’m never satisfied"
			]
		],
		[
			[
				"11:29/29"
			],
			[
				"I have never been satisfied"
			]
		],
		[
			[
				"11:81/75-81"
			],
			[
				"You will never be satisfied"
			]
		],
		[
			[
				"11:106/92-111"
			],
			[
				"Be satisfied"
			]
		],
		[
			[
				"11:110/92-111",
				"11:111/92-111"
			],
			[
				"He will never be satisfied",
				"I will never be satisfied"
			]
		],
		[
			[
				"15:6/6-7"
			],
			[
				"The challenge: demand satisfaction"
			]
		],
		[
			[
				"16:4/4"
			],
			[
				"I’m satisfied"
			]
		],
		[
			[
				"23:161/161-167",
				"23:167/161-167"
			],
			[
				"He will never be satisfied",
				"He will never be satisfied",
				"Satisfied",
				"Satisfied…",
				"He will never be satisfied",
				"Satisfied…",
				"Satisfied..."
			]
		],
		[
			[
				"23:169/168-175",
				"23:171/168-175"
			],
			[
				"To be satisfied",
				"Satisfied",
				"Satisfied…"
			]
		],
		[
			[
				"35:45/32-45"
			],
			[
				"Are my answers to your satisfaction?"
			]
		],
		[
			[
				"37:42/36-43",
				"37:43/36-43"
			],
			[
				"You could never be satisfied",
				"God, I hope you’re satisfied"
			]
		]
	],
	"15": [
		[
			[
				"13:7/1-25",
				"13:11/1-25"
			],
			[
				"Love doesn't discriminate",
				"Between the sinners",
				"And the saints",
				"It takes and it takes and it takes",
				"And we keep loving anyway"
			]
		],
		[
			[
				"13:26/26-38",
				"13:30/26-38"
			],
			[
				"Death doesn’t discriminate",
				"Between the sinners",
				"And the saints",
				"It takes and it takes and it takes",
				"And we keep living anyway"
			]
		],
		[
			[
				"13:89/78-98",
				"13:91/78-98"
			],
			[
				"Life doesn't discriminate",
				"Between the sinners and the saints",
				"It takes and it takes and it takes"
			]
		],
		[
			[
				"45:91/90-107",
				"45:92/90-107"
			],
			[
				"Death doesn’t discriminate",
				"Between the sinners and the saints"
			]
		]
	],
	"16": [
		[
			[
				"14:66/66"
			],
			[
				"Don’t do a thing. History will prove him wrong"
			]
		],
		[
			[
				"19:8/1-8"
			],
			[
				"Knowing history has its eyes on me"
			]
		],
		[
			[
				"19:13/13"
			],
			[
				"Who lives, who dies, who tells your story"
			]
		],
		[
			[
				"19:17/17-18",
				"19:19/19",
				"19:19/19"
			],
			[
				"History has its",
				"Eyes on you.",
				"History has its eyes on you"
			]
		],
		[
			[
				"23:176/176-178",
				"23:179/179-181",
				"23:181/179-181"
			],
			[
				"History has its eyes…",
				"On…",
				"You!",
				"History has its eyes…",
				"On…",
				"You..."
			]
		],
		[
			[
				"23:187/187"
			],
			[
				"History has its eyes on you"
			]
		],
		[
			[
				"32:68/66-74"
			],
			[
				"History has its eyes on you"
			]
		],
		[
			[
				"45:94/90-107"
			],
			[
				"History obliterates"
			]
		],
		[
			[
				"46:4/4-6",
				"46:6/4-6"
			],
			[
				"Who lives",
				"Who dies",
				"Who tells your story?"
			]
		],
		[
			[
				"46:10/10-12",
				"46:12/10-12"
			],
			[
				"Who lives",
				"Who dies",
				"Who tells your story?"
			]
		],
		[
			[
				"46:17/17-19",
				"46:19/17-19"
			],
			[
				"Who lives",
				"Who dies",
				"Who tells your story?"
			]
		],
		[
			[
				"46:24/24-25",
				"46:25/24-25"
			],
			[
				"Who tells your story?",
				"Who tells your story?"
			]
		],
		[
			[
				"46:34/34"
			],
			[
				"She tells our story"
			]
		],
		[
			[
				"46:41/41"
			],
			[
				"We tell your story"
			]
		],
		[
			[
				"46:54/54"
			],
			[
				"She tells my story"
			]
		],
		[
			[
				"46:59/58-60"
			],
			[
				"Will they tell our story?"
			]
		],
		[
			[
				"46:72/70-74"
			],
			[
				"Will they tell my story?"
			]
		],
		[
			[
				"46:76/76-80",
				"46:80/76-80"
			],
			[
				"Will they tell your story?",
				"Who lives, who dies, who tells your story?",
				"Will they tell your story?",
				"Who lives, who dies—",
				"Who tells your story?"
			]
		]
	],
	"17": [
		[
			[
				"15:1/1",
				"15:2/2",
				"15:2/2"
			],
			[
				"One, two, three, four",
				"Five, six, seven, eight, nine…"
			]
		],
		[
			[
				"15:45/45-46",
				"15:46/45-46"
			],
			[
				"One two three four",
				"Five six seven eight nine"
			]
		],
		[
			[
				"26:1/1-6",
				"26:7/7-12",
				"26:13/13",
				"26:13/13"
			],
			[
				"Un deux trois quatre",
				"Cinq six sept huit neuf",
				"Good! Un deux trois quatre",
				"Cinq six sept huit neuf",
				"Sept huit neuf—",
				"Sept huit neuf—",
				"Un deux trois quatre",
				"Cinq six sept huit neuf",
				"Un deux trois quatre",
				"Cinq six sept huit neuf",
				"Sept huit neuf—",
				"Sept huit neuf—",
				"One two three four five six seven eight nine!"
			]
		],
		[
			[
				"26:49/39-49"
			],
			[
				"Un deux trois quatre cinq!"
			]
		],
		[
			[
				"39:79/79",
				"39:80/80",
				"39:80/80"
			],
			[
				"One two three four",
				"Five six seven—"
			]
		],
		[
			[
				"40:39/39-46",
				"40:40/39-46"
			],
			[
				"Un deux trois quatre",
				"Cinq six sept huit neuf"
			]
		],
		[
			[
				"40:42/39-46",
				"40:46/39-46"
			],
			[
				"Un deux trois quatre",
				"Cinq six sept",
				"Huit neuf",
				"Sept huit neuf—",
				"Sept huit…"
			]
		],
		[
			[
				"45:1/1",
				"45:2/2",
				"45:2/2"
			],
			[
				"One two three four",
				"Five six seven eight nine—"
			]
		],
		[
			[
				"45:41/41-42"
			],
			[
				"One two three four five six seven eight nine"
			]
		]
	],
	"18": [
		[
			[
				"17:23/18-45"
			],
			[
				"Just stay alive, that would be enough"
			]
		],
		[
			[
				"17:27/18-45"
			],
			[
				"That would be enough"
			]
		],
		[
			[
				"17:31/18-45",
				"17:34/18-45"
			],
			[
				"But I’m not afraid",
				"I know who I married",
				"So long as you come home at the end of the day",
				"That would be enough"
			]
		],
		[
			[
				"17:43/18-45",
				"17:45/18-45"
			],
			[
				"And I could be enough",
				"And we could be enough",
				"That would be enough"
			]
		],
		[
			[
				"23:126/122-128",
				"23:128/122-128"
			],
			[
				"And if your wife could share a fraction of your time",
				"If I could grant you peace of mind",
				"Would that be enough?"
			]
		],
		[
			[
				"23:160/160"
			],
			[
				"Look around, isn’t this enough?"
			]
		],
		[
			[
				"23:168/168-175"
			],
			[
				"What would be enough"
			]
		],
		[
			[
				"23:174/168-175",
				"23:175/168-175"
			],
			[
				"Isn’t this enough?",
				"What would be enough?"
			]
		],
		[
			[
				"41:27/25-40",
				"41:28/25-40"
			],
			[
				"I know I don’t deserve you, Eliza",
				"But hear me out. That would be enough"
			]
		],
		[
			[
				"41:32/25-40"
			],
			[
				"And you would smile, and that would be enough"
			]
		],
		[
			[
				"41:37/25-40",
				"41:40/25-40"
			],
			[
				"But I’m not afraid",
				"I know who I married",
				"Just let me stay here by your side",
				"That would be enough"
			]
		],
		[
			[
				"41:56/56-59",
				"41:57/56-59"
			],
			[
				"Forgiveness. Can you imagine?",
				"Forgiveness. Can you imagine?"
			]
		],
		[
			[
				"44:7/7"
			],
			[
				"Come back to bed. That would be enough"
			]
		],
		[
			[
				"46:31/29-31"
			],
			[
				"It’s not enough"
			]
		],
		[
			[
				"46:58/58-60"
			],
			[
				"And when my time is up, have I done enough?"
			]
		],
		[
			[
				"46:71/70-74"
			],
			[
				"Have I done enough?"
			]
		]
	],
	"19": [
		[
			[
				"17:35/18-45"
			],
			[
				"We don’t need a legacy"
			]
		],
		[
			[
				"17:39/18-45",
				"17:40/18-45"
			],
			[
				"Oh, let me be a part of the narrative",
				"In the story they will write someday"
			]
		],
		[
			[
				"28:7/7"
			],
			[
				"They renamed it after him. The Mercer legacy is secure"
			]
		],
		[
			[
				"28:125/124-126",
				"28:126/124-126"
			],
			[
				"I wanna build something that’s gonna",
				"Outlive me"
			]
		],
		[
			[
				"36:43/38-43"
			],
			[
				"Way I can protect my legacy…"
			]
		],
		[
			[
				"38:32/1-54"
			],
			[
				"You and your words, obsessed with your legacy..."
			]
		],
		[
			[
				"38:37/1-54"
			],
			[
				"I’m erasing myself from the narrative"
			]
		],
		[
			[
				"39:7/1-10"
			],
			[
				"I shoulder his legacy with pride"
			]
		],
		[
			[
				"39:14/12-15"
			],
			[
				"He disparaged my father’s legacy in front of a crowd"
			]
		],
		[
			[
				"45:50/43-70",
				"45:51/43-70"
			],
			[
				"What if this bullet is my legacy?",
				"Legacy. What is a legacy?"
			]
		],
		[
			[
				"46:27/27"
			],
			[
				"I put myself back in the narrative"
			]
		]
	],
	"20": [
		[
			[
				"22:10/1-15",
				"22:12/1-15"
			],
			[
				"If we lay a strong enough foundation",
				"We’ll pass it on to you, we’ll give the world to you",
				"And you’ll blow us all away…"
			]
		],
		[
			[
				"22:14/1-15"
			],
			[
				"Yeah, you’ll blow us all away"
			]
		],
		[
			[
				"22:33/30-38",
				"22:35/30-38"
			],
			[
				"If we lay a strong enough foundation",
				"We’ll pass it on to you, we’ll give the world to you",
				"And you’ll blow us all away..."
			]
		],
		[
			[
				"22:37/30-38"
			],
			[
				"Yeah, you’ll blow us all away"
			]
		],
		[
			[
				"22:37/30-38"
			],
			[
				"Yeah, you’ll blow us all away"
			]
		],
		[
			[
				"39:11/11"
			],
			[
				"Blow us all away"
			]
		],
		[
			[
				"39:23/23"
			],
			[
				"Blow us all away!"
			]
		]
	],
	"21": [
		[
			[
				"28:33/29-46",
				"28:40/29-46"
			],
			[
				"No one else was in",
				"The room where it happened",
				"The room where it happened",
				"The room where it happened",
				"No one else was in",
				"The room where it happened",
				"The room where it happened",
				"The room where it happened"
			]
		],
		[
			[
				"28:45/29-46",
				"28:46/29-46"
			],
			[
				"But no one else is in",
				"The room where it happens."
			]
		],
		[
			[
				"28:61/60-61",
				"28:62/62-64",
				"28:65/65",
				"28:66/66-68",
				"28:68/66-68"
			],
			[
				"No one else was in—",
				"The room where it happened",
				"The room where it happened",
				"The room where it happened",
				"No one else was in—",
				"The room where it happened",
				"The room where it happened",
				"The room where it happened"
			]
		],
		[
			[
				"28:75/69-75"
			],
			[
				"The room where it happens."
			]
		],
		[
			[
				"28:93/93",
				"28:94/94-95",
				"28:96/96-101",
				"28:101/96-101"
			],
			[
				"No!",
				"—one else was in",
				"The room where it happened",
				"The room where it happened",
				"The room where it happened",
				"No one else was in",
				"The room where it happened",
				"The room where it happened",
				"The room where it happened"
			]
		],
		[
			[
				"28:106/106"
			],
			[
				"And no one else was in the room where it happened"
			]
		],
		[
			[
				"28:131/131-167",
				"28:167/131-167"
			],
			[
				"I",
				"Wanna be in",
				"The room where it happens",
				"The room where it happens",
				"I",
				"Wanna be in",
				"The room where it happens",
				"The room where it happens",
				"I",
				"Wanna be",
				"In the room where it happens",
				"I",
				"I wanna be in the room…",
				"Oh",
				"Oh",
				"I wanna be",
				"I wanna be",
				"I’ve got to be",
				"I’ve got to be",
				"In that room",
				"In that big ol’ room\tCOMPANY",
				"I wanna be in",
				"The room where it happens",
				"The room where it happens",
				"The room where it happens",
				"I wanna be in the room",
				"Where it happens",
				"The room where it happens",
				"The room where it happens",
				"I wanna be in",
				"The room where it happens",
				"The room where it happens",
				"The room where it happens",
				"I wanna be in",
				"The room where it happens",
				"The room where it happens",
				"The room where it happens."
			]
		],
		[
			[
				"28:175/175-182",
				"28:181/175-182",
				"28:181/175-182"
			],
			[
				"I’ve got to be in the room…",
				"I’ve got to be...",
				"I’ve got to be...",
				"Oh, I’ve got to be in",
				"The room where it happens…",
				"I’ve got to be, I’ve gotta be, I’ve gotta be…",
				"In the room!"
			]
		],
		[
			[
				"28:175/175-182",
				"28:181/175-182",
				"28:181/175-182"
			],
			[
				"I’ve got to be in the room…",
				"I’ve got to be...",
				"I’ve got to be...",
				"Oh, I’ve got to be in",
				"The room where it happens…",
				"I’ve got to be, I’ve gotta be, I’ve gotta be…",
				"In the room!"
			]
		],
		[
			[
				"35:24/24"
			],
			[
				"No one else was in the room where it happened"
			]
		],
		[
			[
				"42:64/64-65"
			],
			[
				"No. I’m chasing what I want"
			]
		],
		[
			[
				"43:9/1-9",
				"43:10/10-11",
				"43:12/12",
				"43:13/13",
				"43:14/14-29",
				"43:14/14-29"
			],
			[
				"I wanna be in the room where it happens—",
				"The room where it happens",
				"The room where it happens",
				"You’ve kept me from—",
				"The room where it happens",
				"For the last time"
			]
		]
	]
};


/*****************
 ** WEBPACK FOOTER
 ** ./src/data/themes.json
 ** module id = 216
 ** module chunks = 0
 **/